import React, { useState, useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Helmet from 'react-helmet';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar,
} from "../../../partials/content/Portlet";
import { DataTable, DateRangeControl, TableLevelAction, TablePaginationActions } from '../../../common';
import { Grid, IconButton, Stack, TablePagination, Tooltip } from '@mui/material';
import { adjustCurrentPage } from '../../../util';
import { useStatePtr } from '@pure-ptr/react';
import GetAppIcon from '@mui/icons-material/GetApp';

const useStyles = makeStyles((theme) => ({
    portlet: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

export default function CreditsUsageReportComponent(props) {
    const {
        filteredData, fields, listPending, order, sort, initialDates, downloadReportPending,
        actions: {
            creditsUsageReportLanding, setFilter, setSort, setOrder, 
            downloadCreditUsageReport, resetTable
        }
    } = props;

    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = useState(0);
    const dateRangePtr = useStatePtr(initialDates);

    useEffect(() => {
        if(dateRangePtr?.value?.beginDate && dateRangePtr?.value?.endDate) {
            creditsUsageReportLanding(dateRangePtr?.value?.beginDate, dateRangePtr?.value?.endDate);
        }

        return function cleanup() {
            resetTable();
        }
    }, [creditsUsageReportLanding, dateRangePtr.value]);

    useEffect(() => {
        let currentPage = page + 1; 
        let totalRecords = filteredData?.length;
        let pageSize = rowsPerPage;

        currentPage = adjustCurrentPage(currentPage, totalRecords, pageSize);
        if (page === currentPage - 1) return;
        setPage(currentPage - 1);
    }, [filteredData]);

    function handleRefresh() {
        resetTable();
        creditsUsageReportLanding(dateRangePtr?.value?.beginDate, dateRangePtr?.value?.endDate);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const setDates = (beginDate, endDate) => {
        dateRangePtr.set({
            beginDate,
            endDate,
        });
    }

    function downloadReportCallback({ file, fileName }) {
        let url = window.URL.createObjectURL(file);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${fileName.replace(/\s/g, '')}`;
        a.click();
    }

    return (
        <>
            <Helmet title="Credits Usage Report" />
            <Portlet>
            <PortletHeader
                    title="Credits Usage Report"
                    name="credits-usage-report-landing"
                    toolbar={
                        <PortletHeaderToolbar fullWidth className={classes.portlet}>
                                    <DateRangeControl
                                        // refresh={handleRefresh}
                                        filterName="Date Filter"
                                        setDates={setDates}
                                        enabledSwitch={false}
                                        style={{width:"200px"}}
                                        containerStyles={{width:"200px"}}
                                    />
                        </PortletHeaderToolbar>
                    }
                />
                <PortletBody>
                    <Stack direction="column" spacing={1} sx={{ height: '100%', minHeight: 280 }}>
                        <TableLevelAction
                            handleRefresh={handleRefresh}
                            actions={ () =>
                                <>
                                    <Grid item>
                                        <Tooltip title="Export">
                                            <IconButton aria-label="export" size='small' 
                                                onClick={()=>downloadCreditUsageReport(dateRangePtr?.value?.beginDate, dateRangePtr?.value?.endDate, downloadReportCallback)} 
                                                disabled={downloadReportPending}
                                            >
                                                <GetAppIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </>
                            }
                            
                            loading={downloadReportPending}
                            actionLevelGrid={ () =>
                                <Grid container>
                                    <Grid item md={12}>
                                    <h6 className="">{`Total Transactions : ${filteredData?.length > 0 ? filteredData?.reduce((sum, item) => sum + (item.transectionCount || 0), 0) : 0}`}</h6>
                                    </Grid>
                                </Grid>
                            }
                        />
                        <DataTable
                            loading={listPending}
                            size="medium"
                            fields={fields}
                            data={filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                            order={order}
                            onOrder={setOrder}
                            sort={sort}
                            onSort={setSort}
                            stickyHeader={true}
                            showPagination={true}
                            footerPagination={() => (
                                <TablePagination
                                    rowsPerPageOptions={[10, 50, 100, 250, 500, { label: 'All', value: -1 }]}
                                    colSpan={fields.length + 2}
                                    count={filteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: { 'aria-label': 'rows per page' },
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            )}
                            name="Credits Usage Repport"
                        />
                    </Stack>
                </PortletBody>
            </Portlet>
        </>
    );
}